// extracted by mini-css-extract-plugin
export default {"error":"error_error__TJcy4","code":"error_code__D9wA7","noise-anim":"error_noise-anim__bCjs6","noise-anim-2":"error_noise-anim-2__fH+Av"};